import React, { useState, useContext, useEffect } from 'react';
import '../styles/Produit.css';
import { PanierContext } from '../context/PanierContext';
import { getProduitsValidesAvecVendeur } from '../services/admin/adminProduitService';
import { FaMapMarkerAlt, FaTimes, FaHeart } from 'react-icons/fa';
import '../styles/accueil/ModalProduit.css';
import { asset } from '../services/api';

function Produit() {
  const { ajouterAuPanier } = useContext(PanierContext);
  const [produits, setProduits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [quantities, setQuantities] = useState({});
  const [filtreUnique, setFiltreUnique] = useState('');
  const [selectedProduit, setSelectedProduit] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'fr'); // 🔸 langue actuelle

  const [favoris, setFavoris] = useState(() => {
    return JSON.parse(localStorage.getItem("favoris")) || [];
  });

  // 🔁 Écoute si la langue change dans d’autres composants (NavBar)
 useEffect(() => {
  const handleLangChange = () => {
    setLang(localStorage.getItem('lang') || 'fr');
  };

  window.addEventListener('langChanged', handleLangChange);
  window.addEventListener('storage', handleLangChange);

  return () => {
    window.removeEventListener('langChanged', handleLangChange);
    window.removeEventListener('storage', handleLangChange);
  };
}, []);


  const toggleFavori = (produit) => {
    const key = `${produit.id}-${produit.vendeur_id}`;
    const favorisActuels = JSON.parse(localStorage.getItem("favoris")) || [];
    const existe = favorisActuels.find((f) => f.id === produit.id);
    let newFavoris = existe
      ? favorisActuels.filter((f) => f.id !== produit.id)
      : [...favorisActuels, produit];
    setFavoris(newFavoris);
    localStorage.setItem("favoris", JSON.stringify(newFavoris));
  };

  const getProduitKey = (p) => `${p.id}-${p.vendeur_id}`;

  useEffect(() => {
    const fetchProduits = async () => {
      try {
        const data = await getProduitsValidesAvecVendeur();
        setProduits(Array.isArray(data) ? data : []);
      } catch (err) {
        setError('Impossible de récupérer les produits');
      } finally {
        setLoading(false);
      }
    };
    fetchProduits();
  }, []);

  const produitsFiltres = produits.filter((prod) => {
    if (!filtreUnique) return true;
    const t = filtreUnique.toLowerCase();
    return (
      (prod.title && prod.title.toLowerCase().includes(t)) ||
      (prod.lieu && prod.lieu.toLowerCase().includes(t)) ||
      (prod.categorie && prod.categorie.toLowerCase().includes(t))
    );
  });

  const productsPerPage = 10;
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = produitsFiltres.slice(indexOfFirstProduct, indexOfLastProduct);

  const handleQuantityChange = (key, value) => {
    const onlyDigits = String(value).replace(/\D/g, '');
    let qty = parseInt(onlyDigits || '1', 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    setQuantities((prev) => ({ ...prev, [key]: qty }));
  };

  const handleAddToCart = (product, key, e) => {
    if (e) e.stopPropagation();
    const quantity = Math.max(1, parseInt(quantities[key], 10) || 1);
    const unitPrice = parseInt(product.price, 10) || 0;
    ajouterAuPanier({
      id: key,
      nom: product.title || product.titre,
      title: product.title || product.titre,
      prix: unitPrice,
      quantite: quantity,
      unite: product.unite || 'kg',
      vendeurId: product.vendeur_id,
      img: product.img,
      lieu: product.lieu,
    });
  };

  const openModal = (produit, e) => {
    if (e && e.target.closest('.product-actions, .categorie-button-container')) return;
    setSelectedProduit(produit);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedProduit(null);
  };

  if (loading) return <div>{lang === 'fr' ? 'Chargement...' : 'Miandry kely...'}</div>;
  if (error) return <div>{lang === 'fr' ? error : 'Tsy afaka naka vokatra.'}</div>;

  return (
    <div className="produit-container main-content">
      <div className="produit-header-bar">
        <h1>{lang === 'fr' ? 'Nos Produits' : 'Ny vokatray'}</h1>
        <div className="product-filters">
          <input
            type="text"
            placeholder={
              lang === 'fr'
                ? '🔎 Rechercher un produit, lieu, catégorie'
                : '🔎 Karohy vokatra, toerana, sokajy'
            }
            value={filtreUnique}
            onChange={(e) => {
              setFiltreUnique(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>

      <div className="product-list">
        {currentProducts.length === 0 ? (
          <div className="no-products-message">
            {filtreUnique
              ? lang === 'fr'
                ? `Il n'y a pas de produits "${filtreUnique}" dans notre plateforme.`
                : `Tsy misy vokatra "${filtreUnique}" amin'ny tranonkalanay.`
              : lang === 'fr'
              ? `Il n'y a pas de produits dans notre plateforme.`
              : `Tsy misy vokatra amin'ny tranonkalanay.`}
          </div>
        ) : (
          currentProducts.map((product) => {
            const uniqueId = getProduitKey(product);
            const unite = product.unite || 'kg';
            return (
              <div className="product-card" key={uniqueId}>
                <div className="product-top">
                  <img
                    src={asset(product.img)}
                    alt={product.title || product.titre}
                    onClick={(e) => openModal(product, e)}
                    style={{ cursor: 'pointer' }}
                  />
                </div>

                <div className="product-info">
                  <h3>{product.title || product.titre}</h3>
                  <p>
                    <strong>{lang === 'fr' ? 'Catégorie :' : 'Sokajy :'}</strong>{' '}
                    {product.categorie}
                  </p>
                  <p className="product-lieu">
                    <FaMapMarkerAlt style={{ color: '#2e5d3d' }} /> {product.lieu}
                  </p>

                  <div className="price-container">
                    <span>
                      {product.price} Ar / {unite}
                    </span>
                  </div>

                  <div className="product-actions">
                    <label>{lang === 'fr' ? 'Quantité' : 'Isan\'ny vokatra'} ({unite}) :</label>
                    <input
                      type="number"
                      min="1"
                      step="1"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={quantities[uniqueId] || 1}
                      onChange={(e) => handleQuantityChange(uniqueId, e.target.value)}
                    />
                  </div>

                  <div className="categorie-button-container">
                    <button
                      type="button"
                      onClick={(e) => handleAddToCart(product, uniqueId, e)}
                      className="add-to-cart-btn"
                    >
                      {lang === 'fr' ? 'Ajouter au panier' : 'Ampidiro ao anaty harona'}
                    </button>

                    <FaHeart
                      className="favori-icon"
                      onClick={() => toggleFavori(product)}
                      color={favoris.some((f) => f.id === product.id) ? 'red' : '#ccc'}
                      style={{ cursor: 'pointer', fontSize: '22px', marginLeft: '10px' }}
                    />
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      <div className="pagination">
        {Array.from({ length: Math.ceil(produitsFiltres.length / productsPerPage) }, (_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? 'active' : ''}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {showModal && selectedProduit && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <FaTimes className="modal-close-icon" onClick={closeModal} />
            <h2>{selectedProduit.title || selectedProduit.titre}</h2>

            <img
              src={asset(selectedProduit.img)}
              alt={selectedProduit.title || selectedProduit.titre}
              style={{ maxWidth: '100%', borderRadius: '8px' }}
            />
            <p>
              <strong>{lang === 'fr' ? 'Description :' : 'Famaritana :'}</strong>{' '}
              {selectedProduit.description}
            </p>
            <p>
              <strong>{lang === 'fr' ? 'Description détaillée :' : 'Famaritana feno :'}</strong>{' '}
              {selectedProduit.description_detaillee}
            </p>
            <p>
              <strong>{lang === 'fr' ? 'Catégorie :' : 'Sokajy :'}</strong>{' '}
              {selectedProduit.categorie}
            </p>
            <p>
              <strong>{lang === 'fr' ? 'Lieu :' : 'Toerana :'}</strong> {selectedProduit.lieu}
            </p>
            <p>
              <strong>{lang === 'fr' ? 'Prix :' : 'Vidiny :'}</strong> {selectedProduit.price} Ar /{' '}
              {selectedProduit.unite || 'kg'}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Produit;
